<template>
    <div>
        <template v-for="( key, index ) in headers">
            <span
                v-if="key === 'name'"
                :class="[
                    'table__body__row__text position--relative',
                    `table__${model}__col__${index}`
                ]"
                :key="index"
            >
                {{ row[key] || ''}}
            </span>
        </template>
        <div
            :class="[
                'row__mail-template__actions display--flex',
                `table__${model}__col__2`,
                { 'row__mail-template__actions--end': row.enabled || !$store.getters.can( 'campaign', 'editMailTemplate' ) }
            ]"
        >
            <table-actions
                v-if="!row.enabled"
                :settings="{
                    model: 'mailTemplates',
                    delete: {
                        action: deleteMailTemplate
                    }
                }"
            />
            <router-link
                :to="`/campaigns/${$route.params.id}/mail-templates/${row.id}`"
                class="table__body__row__icon row__mail-template__anchor position--relative accessibility--button"
            >
                <icon-info class="row__mail-template__icon"/>
            </router-link>
        </div>
    </div>
</template>

<script>
// store
import { useActions } from '@/hooks/use-store';

// hooks
import tableStructure from '@/hooks/use-table';

export default {
    components: {
        TableActions: () => import( /* webpackChunkName: 'TableActions' */ '@/components/bundles/tables/packs/TableActions' ),
        IconInfo: () => import( /* webpackChunkName: 'IconInfo' */ '@/components/bundles/layout/images/icons/IconInfo' )
    },
    ...tableStructure,
    setup ( props, { parent, root }) {
        // obtenção das acções da store.
        const { actions } = useActions();

        /**
         * [method]
         * Emissão das configurações da página, como
         * o bloqueio da barra de acções e abertura
         * da modal de confirmação.
         *
         * @param {String} type
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const emitConfigs = ( type = 'active' ) => {
            // bloqueia a barra de adição & edição.
            actions( 'controlActionBar', { value: true });

            // trigger para abrir a modal.
            parent.$emit( 'open-modal', { actionType: type });
        };

        /**
         * [method]
         * Apagar um template de e-mail.
         * É emitido as configs & definição dos
         * valores a serem enviados para API.
         *
         * @since 1.2.3
         * @category Method
         * @autor Jorge Monteiro
         *
        */
        const deleteMailTemplate = () => {
            emitConfigs( 'delete' );

            // definição do ID.
            actions( 'registerField', { name: 'id', value: props.row.id });
            actions( 'registerField', { name: 'endpoint', value: `/campaigns/${root.$route.params.id}/mail-templates` });
        };

        return { deleteMailTemplate };
    }
};
</script>

<style lang="scss">
    .row {
        &__mail-template {
            &__anchor {
                height: 26px;
            }
            &__icon {
                @include dimensions( 26px, 26px );
            }
            &__actions {
                gap: 10px;
                &--end {
                    justify-content: flex-end;
                }
            }
        }
    }
</style>